import { Text } from '@plato/ui-legacy/components/ui/text';
import type { LucideIcon } from 'lucide-react';
import type React from 'react';

type DashboardActivityItemProps = {
    icon: LucideIcon;
    primaryText: React.ReactNode;
    secondaryText?: string;
    tail?: React.ReactNode;
    onClick?: () => void;
};

export function DashboardActivityItem({
    icon: Icon,
    primaryText,
    secondaryText,
    tail,
    onClick,
}: DashboardActivityItemProps) {
    return (
        <button
            className="flex flex-col xl:gap-1 gap-0.5 px-3 xl:py-2 py-1.5 w-full overflow-hidden text-left hover:bg-neutral-50"
            onClick={onClick}
        >
            <div className="flex items-center justify-between w-full overflow-hidden gap-3">
                <div className="flex items-center gap-2 grow shrink overflow-hidden">
                    <div className="shrink-0">
                        <Icon className="h-4 w-4 text-neutral-700" />
                    </div>
                    <Text
                        className="grow overflow-hidden whitespace-nowrap text-ellipsis h-5"
                        color="neutral-950"
                    >
                        {primaryText}
                    </Text>
                </div>
                {tail && (
                    <Text color="neutral-600" className="shrink-0">
                        {tail}
                    </Text>
                )}
            </div>
            {secondaryText && (
                <Text className="truncate w-full pl-6" color="neutral-600">
                    {secondaryText}
                </Text>
            )}
        </button>
    );
}
